/**
 * currentUser state
 */
import { createAction, getType } from "typesafe-actions";

import { ADUser } from "../../types/models";
import { RootAction } from "../actions";
import { msalInstance } from "src/msalConfig";

export type UserState = ADUser;

const initialState: any = null;

// Reducer
export default function reducer(state = initialState, action: RootAction) {
  switch (action.type) {
    case getType(actions.setCurrentUser):
      return action.payload;
    default:
      return state;
  }
}

// Actions
export const actions = {
  setCurrentUser: createAction("@user/setCurrentUser")<ADUser>(),
};

// Action Creators

export const getCurrentUser = () => async (dispatch: any) => {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No signed-in user.");
    }

    const account = accounts[0];
    const user = {
      userName: account?.username ?? '',
    };

    dispatch(actions.setCurrentUser(user));

    return user;
  } catch (err) {
    console.error("getCurrentUser error", err);
    throw err;
  }
};
